
import jsonp from "../../../../assets/js/http";

import { Component , Vue , Watch} from "vue-property-decorator";
@Component
export default class shareData extends Vue {
	// get roomDatail(){
	// 	return this.$store.getters["getRoomDetail/getStatus"];
	// }
	mainTitleNum:number = 15 //主标题限制字数
	subTitleNum:number = 30 //副标题限制字数
    isShareData:boolean = true // 弹窗boolean
	posterUrl:any =null // 缩略图地址
	closeIcon:any=require("@/assets/img/poster-poup-close.png")
	shareInfoImg:any=require("@/assets/img/shareImg.png")
	auditStatusText:string="提交审核"
	uploadInfo:any=null//待上传图片
	isDesabled:boolean=true;
	shareData:any={
		main_title:'' ,//主标题
		sub_title:'',//副标题
		remark:'',//审核理由
		url:'',//图片地址
		audit_status:0 // 审核状态
	}
	api:any={
		shareSubmit: "https://opc" + this.domain + "/ule-live-amdin/api/v1/room/share/submit",//上传分享信息接口
		getShareData:"https://opc" + this.domain + "/ule-live-amdin/api/v1/room/share/detail"
	}
    @Watch('isShareData') 
	onChange(val:any,oldVal:any){
        if(!val){
            this.$emit('hintChange' , {name:'isShareData',val:val})
        }
	}
	mounted() {
		this.getShareData()
	}
	mainTitleChange(){//主标题改变
        const len =this.shareData.main_title.length;    
        if(len>this.mainTitleNum){
            this.shareData.main_title = this.shareData.main_title.substring(0,this.mainTitleNum);
        }
		this.btnChange()
	}
	subTitleChange(){//副标题改变
		const len =this.shareData.sub_title.length;    
        if(len>this.subTitleNum){
            this.shareData.sub_title = this.shareData.sub_title.substring(0,this.subTitleNum);
        }
		this.btnChange()
	}
	btnChange(){
		this.auditStatusText="提交审核";
		this.shareData.audit_status = 0
		if(this.shareData.main_title && this.shareData.sub_title && (this.shareData.url || this.uploadInfo)){
			this.isDesabled=false;//设置按钮状态为可点击
		}else{
			this.isDesabled=true;//设置按钮状态为不可点击
		}
	}
	getShareData(){//获取直播间分享设置
		this.fetch({
			url: this.api.getShareData+"?room_id="+this.$route.params.id,
			method: "get"
		}).then((res:any) => {
			if(res){
				res.url = res.url.replace(/http:/, "https:")
				this.auditStatusText=res.audit_status?this.filterStatus(res.audit_status):"提交审核";
				this.shareData = res
			}
		}).catch((err:any)=>{
			
		})		
	}
	//分享缩略图尺寸、大小、格式判断
	beforeRead(file:any,d:any) {
		console.log('上传的文件信息',file)
		let maxSize= 1 * 32 * 1024;//最大文件不能超过32KB
		//读取上传的图片文件，获取图片尺寸
		let reader:any = new FileReader();
		reader.readAsDataURL(file.file);
		reader.onload = (theFile:any)=>{
			let image:any = new Image();
		　 	image.src = theFile.target.result; 
		　  image.onload = ()=>{
				console.log(image.width,image.height)
				file.status = 'uploading';
      			file.message = '上传中...';
				if(image.width!='300' || image.height!='300'){
					this.$toast("请上传宽300*高300的图片");
					return false
				}else{
					if(maxSize<file.file.size){
						this.$toast("请上传小于32KB大小的图片");
						return false
					}else{
						if (file.file.type !== 'image/jpeg' && file.file.type !== 'image/png') {
							this.$toast("请上传JPG或PNG格式的图片");
							return false;
						}else{
							this.uploadInfo=file.file;
							this.shareData.url = file.content;
							this.btnChange()
							return true;
						}
					}
				}
			};
		};
	}
	//上传分享信息
	uploadShare(file:any){
		let params = new FormData();
      	params.append("file",file); // 文件对象
		params.append('room_id',this.$route.params.id);  //添加其他参数
		params.append('main_title',this.shareData.main_title);  //主标题
		params.append('sub_title',this.shareData.sub_title);  //副标题
		params.append('url',this.shareData.url);  //已有分享图片
		
		this.fetch({
			url: this.api.shareSubmit,
			data:params,
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then((res:any) => {
			this.isDesabled=true;
			this.uploadInfo=null;//重置待上传图片
			this.$dialog.alert({
				message: "提交审核成功，邮乐运营同事将尽快完成审核，如若长时间未审核，请联系相关邮乐运营同事",
			}).then(() => {
				this.isShareData = false
			});
		}).catch((err:any)=>{
			this.$toast(err.data);
		})
	}
	//海报上传状态过滤
	filterStatus(status:0){
		let textArr=["提交审核","待审核","生效中","审核拒绝"];
		return textArr[status];
	}
	//提交审核
	submitShare(){
		if(!this.shareData.main_title){
			this.$toast('请录入主标题');
			return false
		}
		if(!this.shareData.sub_title){
			this.$toast('请录入副标题');
			return false
		}
		if(!this.shareData.url && !this.uploadInfo){
			this.$toast('请上传缩略图');
			return false
		}
		this.uploadShare(this.uploadInfo);
	}
}
